import CloseBusiness from './CloseBusiness';

export default CloseBusiness;